export const locationsTranslations = {
  en: {
    hero: {
      home: 'Home',
      locations: 'Locations',
      heading: 'Our Locations',
      subheading: 'Premium Training Facilities Across Bulgaria',
      tagline: 'World-class sports venues in strategic locations',
    },
    main: {
      heading: 'Explore Our Premium Facilities',
      viewGallery: 'View Gallery',
      facilities: 'Facilities:',
      capacity: 'Capacity:',
      surface: 'Surface:',
      availableSports: 'Available Sports:',
      viewDetails: 'View Details',
      hideDetails: 'Hide Details',
      bookNow: 'Book Now',
    },
    locations: [
      {
        name: 'Kranevo',
        location: 'Kranevo',
        sports: ['Beach Sports', 'Multi-Sport'],
        description: "Located on Bulgaria's beautiful Black Sea coast, Kranevo offers a unique training environment combining beach sports facilities with traditional training venues.",
        facilities: ['Beach volleyball courts', 'Indoor sports halls', 'Outdoor training fields', 'Fitness facilities', 'Beach access'],
        capacity: 'Ideal for summer training camps',
        surface: 'Beach and indoor surfaces',
        availableSports: 'Beach Volleyball, Football, Basketball, Various sports',
        amenities: ['Parking available', 'Changing rooms', 'Equipment rental', 'Nearby accommodation', 'Beach access', 'Cafeteria'],
      },
      {
        name: 'Sofia, Mladost',
        location: 'Sofia, Mladost',
        sports: ['Basketball', 'Volleyball'],
        description: "Sports Hall 'Levski Sofia' is a modern sports hall and the only facility of its kind in Bulgaria. Featuring professional basketball and volleyball courts with state-of-the-art equipment and facilities.",
        facilities: ['Professional basketball court', 'Professional volleyball court', 'Modern locker rooms', 'Equipment storage', 'Spectator seating'],
        capacity: 'Up to 2,000 spectators',
        surface: 'Premium hardwood flooring',
        availableSports: 'Basketball, Volleyball',
        amenities: ['Parking available', 'Changing rooms', 'Equipment rental', 'WiFi available', 'Cafeteria', 'Medical room'],
      },
      {
        name: 'Sofia',
        location: 'Sofia, NSA',
        sports: ['Athletics', 'Track & Field'],
        description: 'The National Sports Academy (NSA) is a specialised higher education institution in Bulgaria with 75 years of history. Featuring world-class athletics facilities and training grounds.',
        facilities: ['400m athletics track', 'Field events areas', 'Indoor training facilities', 'Professional gym', 'Recovery facilities'],
        capacity: 'Large stadium seating',
        surface: 'Professional synthetic track',
        availableSports: 'Athletics, Track & Field, Cross Country',
        amenities: ['Parking available', 'Changing rooms', 'Professional coaching', 'Medical facilities', 'Strength & conditioning gym', 'Sports science lab'],
      },
      {
        name: 'Plovdiv',
        location: 'Plovdiv',
        sports: ['Swimming', 'Water Polo'],
        description: 'A modern aquatic sports center featuring a 50m Olympic swimming pool with 10 lanes—ideal for swimming and water-sports training camps.',
        facilities: ['50m Olympic pool (10 lanes)', 'Diving pool', 'Training pool', 'Modern locker rooms', 'Spectator seating'],
        capacity: '50m x 25m, temperature controlled',
        surface: 'Olympic standard filtration',
        availableSports: 'Swimming, Water Polo, Diving',
        amenities: ['Parking available', 'Changing rooms & showers', 'Equipment rental', 'Timing systems', 'Video analysis room', 'Recovery facilities'],
      },
      {
        name: 'Sofia, Boyana',
        location: 'Sofia, Boyana',
        sports: ['Football'],
        description: 'Home of Football - National Football Base Boyana is a comprehensive sports facility equipped with a wide range of amenities. The sports base nestles in the skirts of Vitosha, includes three football fields (two with natural and one with artificial grass), a grandstand for 348 people overlooks the main pitch, two tennis courts, parking and alleys.',
        facilities: ['Three football fields (2 natural, 1 artificial)', 'Grandstand for 348 people', 'Two tennis courts', 'Gym facilities', 'Conference rooms', 'On-site accommodation'],
        capacity: 'Grandstand for 348 people',
        surface: 'Natural and artificial grass',
        availableSports: 'Football',
        amenities: ['Parking available', 'Changing rooms', 'Equipment rental', 'Cafeteria', 'Meeting rooms', 'On-site accommodation'],
      },
    ],
    benefits: {
      heading: 'Why Choose Bulgaria for Your Training Camp?',
      items: [
        { title: 'Strategic Location', description: 'Centrally located in Europe with easy access from major cities' },
        { title: 'Excellent Value', description: 'World-class facilities at competitive prices' },
        { title: 'Great Climate', description: 'Favorable weather conditions year-round for outdoor training' },
        { title: 'Quality Amenities', description: 'Excellent accommodation, food, and local hospitality' },
        { title: 'Easy Access', description: 'International airports with connections across Europe' },
        { title: 'Experienced Support', description: 'Local expertise in organizing international training camps' },
      ],
    },
    comparison: {
      heading: 'Compare Our Facilities',
      locationName: 'Location Name',
      primarySports: 'Primary Sports',
      capacity: 'Capacity',
      indoorOutdoor: 'Indoor/Outdoor',
      seasonAvailability: 'Season Availability',
      nearbyAccommodation: 'Nearby Accommodation',
      both: 'Both',
      indoor: 'Indoor',
      yearRound: 'Year-round',
      basedOnAvailability: 'Based on availability',
      yes: 'Yes',
      locationLabel: 'Location:',
      primarySportsLabel: 'Primary Sports:',
      capacityLabel: 'Capacity:',
      indoorOutdoorLabel: 'Indoor/Outdoor:',
      seasonLabel: 'Season Availability:',
      nearbyLabel: 'Nearby Accommodation:',
    },
    cta: {
      heading: 'Ready to Book Your Training Facility?',
      text: 'Contact us to discuss your training camp requirements',
      viewPackages: 'View Our Packages',
      contactUs: 'Contact Us',
    },
  },
  ar: {
    hero: {
      home: 'الرئيسية',
      locations: 'المواقع',
      heading: 'مواقعنا',
      subheading: 'مرافق تدريب متميزة في جميع أنحاء بلغاريا',
      tagline: 'ملاعب رياضية عالمية المستوى في مواقع استراتيجية',
    },
    main: {
      heading: 'استكشف مرافقنا المتميزة',
      viewGallery: 'عرض المعرض',
      facilities: 'المرافق:',
      capacity: 'السعة:',
      surface: 'السطح:',
      availableSports: 'الرياضات المتاحة:',
      viewDetails: 'عرض التفاصيل',
      hideDetails: 'إخفاء التفاصيل',
      bookNow: 'احجز الآن',
    },
    locations: [
      {
        name: 'كرانييفو',
        location: 'كرانييفو',
        sports: ['رياضات شاطئية', 'متعدد الرياضات'],
        description: 'تقع كرانييفو على الساحل الجميل للبحر الأسود في بلغاريا، وتوفر بيئة تدريب فريدة تجمع بين مرافق الرياضات الشاطئية وملاعب التدريب التقليدية.',
        facilities: ['ملاعب كرة طائرة شاطئية', 'قاعات رياضية داخلية', 'ملاعب تدريب خارجية', 'مرافق لياقة', 'وصول للشاطئ'],
        capacity: 'مثالي لمعسكرات التدريب الصيفية',
        surface: 'أسطح شاطئية وداخلية',
        availableSports: 'كرة الطائرة الشاطئية، كرة القدم، كرة السلة، رياضات متنوعة',
        amenities: ['موقف سيارات متاح', 'غرف تغيير', 'تأجير معدات', 'إقامة قريبة', 'وصول للشاطئ', 'كافيتريا'],
      },
      {
        name: 'صوفيا، ملادوست',
        location: 'صوفيا، ملادوست',
        sports: ['كرة السلة', 'الكرة الطائرة'],
        description: 'قاعة ليفسكي صوفيا الرياضية هي قاعة رياضية حديثة والمنشأة الوحيدة من نوعها في بلغاريا. تضم ملاعب كرة سلة وطائرة احترافية مع معدات ومرافق حديثة.',
        facilities: ['ملعب كرة سلة احترافي', 'ملعب كرة طائرة احترافي', 'غرف خلع ملابس حديثة', 'تخزين المعدات', 'مقاعد للمتفرجين'],
        capacity: 'حتى 2000 متفرج',
        surface: 'أرضية خشبية متميزة',
        availableSports: 'كرة السلة، الكرة الطائرة',
        amenities: ['موقف سيارات متاح', 'غرف تغيير', 'تأجير معدات', 'واي فاي متاح', 'كافيتريا', 'غرفة طبية'],
      },
      {
        name: 'صوفيا',
        location: 'صوفيا، الأكاديمية الوطنية',
        sports: ['ألعاب القوى', 'الجري والميدان'],
        description: 'الأكاديمية الوطنية للرياضة (NSA) هي مؤسسة تعليم عالي متخصصة في بلغاريا بتاريخ 75 عامًا. تضم مرافق ألعاب قوى وملاعب تدريب عالمية المستوى.',
        facilities: ['مضمار ألعاب قوى 400م', 'مناطق ألعاب الميدان', 'مرافق تدريب داخلية', 'صالة رياضية احترافية', 'مرافق تعافي'],
        capacity: 'مقاعد استاد كبيرة',
        surface: 'مضمار صناعي احترافي',
        availableSports: 'ألعاب القوى، الجري والميدان، العدو الريفي',
        amenities: ['موقف سيارات متاح', 'غرف تغيير', 'تدريب احترافي', 'مرافق طبية', 'صالة قوة وتكييف', 'مختبر علوم الرياضة'],
      },
      {
        name: 'بلوفديف',
        location: 'بلوفديف',
        sports: ['السباحة', 'كرة الماء'],
        description: 'مركز رياضي مائي حديث يضم مسبح أولمبي طوله 50 مترًا و10 حارات — مثالي لمعسكرات تدريب السباحة والرياضات المائية.',
        facilities: ['مسبح أولمبي 50م (10 حارات)', 'مسبح غوص', 'مسبح تدريب', 'غرف خلع ملابس حديثة', 'مقاعد للمتفرجين'],
        capacity: '50م × 25م، درجة حرارة مضبوطة',
        surface: 'ترشيح بأبعاد أولمبية',
        availableSports: 'السباحة، كرة الماء، الغوص',
        amenities: ['موقف سيارات متاح', 'غرف تغيير ودوش', 'تأجير معدات', 'أنظمة توقيت', 'غرفة تحليل فيديو', 'مرافق تعافي'],
      },
      {
        name: 'صوفيا، بويانا',
        location: 'صوفيا، بويانا',
        sports: ['كرة القدم'],
        description: 'موطن كرة القدم - القاعدة الوطنية لكرة القدم في بويانا منشأة رياضية شاملة مجهزة بمجموعة واسعة من المرافق. تقع القاعدة في أحضان فيتوشا، وتضم ثلاثة ملاعب كرة قدم (اثنان بعشب طبيعي وواحد صناعي)، مدرج لـ 348 شخصًا يطل على الملعب الرئيسي، ملعبي تنس، موقف سيارات وممرات.',
        facilities: ['ثلاثة ملاعب كرة قدم (2 طبيعي، 1 صناعي)', 'مدرج لـ 348 شخصًا', 'ملعبي تنس', 'مرافق صالة رياضية', 'قاعات مؤتمرات', 'إقامة في الموقع'],
        capacity: 'مدرج لـ 348 شخصًا',
        surface: 'عشب طبيعي وصناعي',
        availableSports: 'كرة القدم',
        amenities: ['موقف سيارات متاح', 'غرف تغيير', 'تأجير معدات', 'كافيتريا', 'قاعات اجتماعات', 'إقامة في الموقع'],
      },
    ],
    benefits: {
      heading: 'لماذا تختار بلغاريا لمعسكر تدريبك؟',
      items: [
        { title: 'موقع استراتيجي', description: 'تقع في قلب أوروبا مع وصول سهل من المدن الرئيسية' },
        { title: 'قيمة ممتازة', description: 'مرافق عالمية المستوى بأسعار تنافسية' },
        { title: 'مناخ رائع', description: 'ظروف طقس ملائمة للتدريب الخارجي على مدار العام' },
        { title: 'مرافق ذات جودة', description: 'إقامة وطعام وضيافة محلية ممتازة' },
        { title: 'وصول سهل', description: 'مطارات دولية مع ربط عبر أوروبا' },
        { title: 'دعم ذو خبرة', description: 'خبرة محلية في تنظيم معسكرات تدريب دولية' },
      ],
    },
    comparison: {
      heading: 'قارن مرافقنا',
      locationName: 'اسم الموقع',
      primarySports: 'الرياضات الرئيسية',
      capacity: 'السعة',
      indoorOutdoor: 'داخلي/خارجي',
      seasonAvailability: 'التوفر الموسمي',
      nearbyAccommodation: 'إقامة قريبة',
      both: 'كلاهما',
      indoor: 'داخلي',
      yearRound: 'على مدار العام',
      basedOnAvailability: 'حسب التوفر',
      yes: 'نعم',
      locationLabel: 'الموقع:',
      primarySportsLabel: 'الرياضات الرئيسية:',
      capacityLabel: 'السعة:',
      indoorOutdoorLabel: 'داخلي/خارجي:',
      seasonLabel: 'التوفر الموسمي:',
      nearbyLabel: 'إقامة قريبة:',
    },
    cta: {
      heading: 'مستعد لحجز منشأة التدريب؟',
      text: 'اتصل بنا لمناقشة متطلبات معسكر التدريب',
      viewPackages: 'عرض باقاتنا',
      contactUs: 'اتصل بنا',
    },
  },
};
